import cn from 'classnames'
import Image from 'next/image'
import { EnhancedTag } from 'src/components/global/EnhancedTag/EnhancedTag'
import { PremiumTag } from 'src/components/global/PremiumTag/PremiumTag'
import { IEnum_Solution_Item_Type, ISolutionItem } from 'src/graphql/generated/hooks'
import { useDefaultLogo } from 'src/hooks/useDefaultLogo'

import { CompatibleLink } from '../CompatibleLink/CompatibleLink'

interface solutions {
  __typename?: 'SolutionItem'
  id?: ISolutionItem['id']
  displayName?: ISolutionItem['displayName']
  slug?: ISolutionItem['slug']
  logo?: ISolutionItem['logo']
  isPremium?: ISolutionItem['isPremium']
  isEnhanced?: ISolutionItem['isEnhanced']
  subTopics?: ISolutionItem['subTopics']
}

interface Props {
  solution: solutions | undefined | null
  className?: string
  type?: string
}

export const SolutionCarouselCard: React.FC<Props> = ({ className = '', solution, type }) => {
  const avatar = useDefaultLogo(solution?.logo)
  const displayName = solution?.displayName || ''
  const isPremium = solution?.isPremium
  const isEnhanced = solution?.isEnhanced

  let hrefLink = ''
  if (type === IEnum_Solution_Item_Type.Alsp) {
    hrefLink = '/alsps/' + solution?.slug
  } else if (type === IEnum_Solution_Item_Type.Consultancy) {
    hrefLink = '/consultants/' + solution?.slug
  } else if (type === IEnum_Solution_Item_Type.Product) {
    hrefLink = '/vendors/' + solution?.slug
  } else if (type === IEnum_Solution_Item_Type.Company) {
    hrefLink = '/companies/' + solution?.slug
  }

  return (
    <CompatibleLink
      href={hrefLink || '/'}
      passHref
      className="cursor-pointer flex flex-col items-center justify-center w-[172px] h-[154px]"
    >
      <div
        className={cn('w-[80px] h-[80px] flex ite ms-center justify-center overflow-hidden object-cover', className)}
      >
        <Image src={avatar} alt={displayName} width={80} height={80} priority />
      </div>
      {displayName && (
        <p className="font-secondary font-semibold text-center text-textdark text-[14px] leading-[16px] mt-3 h-[40px] overflow-hidden">
          {displayName}
        </p>
      )}
      {isPremium && <PremiumTag variant="yellow" />}
      {!isPremium && isEnhanced && <EnhancedTag />}
    </CompatibleLink>
  )
}
